// extracted by mini-css-extract-plugin
module.exports = {"container":"DefectFilter_container__1dzJp","content":"DefectFilter_content__20wB7","subHeadingText":"DefectFilter_subHeadingText__1wa20","users":"DefectFilter_users__3iCgM"};